import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1f5508cc")
const _hoisted_1 = { class: "overview" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "c-left" }, " 本項目是基於Vue3、Vuex、VueRouter、ElementPlus、TypeScript、Echart等技術的後台解決方案，項目中所有數據都是使用Mock.js進行模擬 ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "c-left" }, "統一使用npm run commit進行命令行交互式提交", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_BaseTextLink = _resolveComponent("BaseTextLink")!
  const _component_BaseDescriptions = _resolveComponent("BaseDescriptions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseCard, { title: "簡介" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_BaseCard, { title: "技術棧" }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTextLink, { "text-arrs": _ctx.technologyStacks }, null, 8, ["text-arrs"])
      ]),
      _: 1
    }),
    _createVNode(_component_BaseCard, { title: "項目規範" }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseDescriptions, {
          title: "全局變量",
          column: 1,
          "table-datas": [{ name: 'VUE_APP_API', description: '後端API的baseURL' }]
        }),
        _createVNode(_component_BaseDescriptions, {
          title: "文件命名規範",
          column: 1,
          "table-datas": [
          { name: '文件夾', description: '小寫，多個單詞使用-分割，EX: nav-bar' },
          {
            name: '文件(.ts .vue .json .d.ts)',
            description: '小寫，多個單詞使用-分割，EX: nav-header.vue'
          }
        ]
        }, null, 8, ["table-datas"]),
        _createVNode(_component_BaseDescriptions, {
          title: "組件編寫規範",
          column: 1,
          "table-datas": [
          { name: '組件結構', description: '放在src資料夾下，統一於index.ts中導出' },
          {
            name: '組件名稱',
            description: '除了全局導入的組件，統一大寫駝峰，EX: NavHeader'
          },
          {
            name: '組件樣式',
            description: '小寫，多個單詞使用-分割，EX: nav-header'
          }
        ]
        }, null, 8, ["table-datas"])
      ]),
      _: 1
    }),
    _createVNode(_component_BaseCard, { title: "git提交規範" }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })
  ]))
}